import { render, staticRenderFns } from "./DialogAddRemark.vue?vue&type=template&id=049b1499&scoped=true"
import script from "./DialogAddRemark.vue?vue&type=script&lang=js"
export * from "./DialogAddRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b1499",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049b1499')) {
      api.createRecord('049b1499', component.options)
    } else {
      api.reload('049b1499', component.options)
    }
    module.hot.accept("./DialogAddRemark.vue?vue&type=template&id=049b1499&scoped=true", function () {
      api.rerender('049b1499', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddRemark.vue"
export default component.exports